import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import IconButton, { type Props as IconButtonProps } from '@wix/da-ds/pkg/Buttons/IconButton';
import ErrorIcon from '@wix/da-ds/pkg/Icons/16x16/ModerationAlert';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import s from './ErrorPostfix.scss';

interface Props {
  onRetry: IconButtonProps['onClick'];
}

/**
 * A button with an error icon inside and an appropriate tooltip. Will call the supplied {@link Props.onRetry|onRetry} function on click.
 */
const ErrorPostfix: React.FC<Props> = ({ onRetry }) => {
  const { t } = useTranslation();
  return (
    <SimpleTooltip text={t('estimatedEarnings.error.tooltip')}>
      {/*
        Having a button labelled "Retry" button doesn't seem like enough, so adding a bit more context
        for our screen reader users.
      */}
      <VisuallyHidden>{t('estimatedEarnings.error.a11y.context')}</VisuallyHidden>
      <IconButton
        size="small"
        icon={ErrorIcon}
        className={s['error-icon']}
        aria-label={t('estimatedEarnings.error.a11y.buttonLabel')}
        onClick={onRetry}
      />
    </SimpleTooltip>
  );
};

ErrorPostfix.displayName = 'ErrorPostfix';

export default ErrorPostfix;
